export default __webpack_public_path__ + "static/media/pattern2.66d096ce.webp";